// removed by extract-text-webpack-plugin
module.exports = {"container":"LP5tqyxQtwuYgBBEI6FGT","Email":"_1f1DJZHZS29ArJ-lbZEYC9","Signer":"_14NAxWsiyEYcw2RAhl7Zbx","Icon":"_3P1vHdhbJ79A4Zz02-NYZ6","Title":"_3JubeZHHItLLpf7LB4x1__"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/PubDocumentVerify/DocVerifier/Verify/FeaSigners/styles.css
// module id = 3021
// module chunks = 0